import { render, staticRenderFns } from "./offline-list.vue?vue&type=template&id=887c4886&"
import script from "./offline-list.vue?vue&type=script&lang=ts&"
export * from "./offline-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports